<template>
  <div class="mb-8">
    <h2 class="text-xl font-bold italic text-[#9D9687] mb-3 border-b border-gray-300 pb-1">{{ title }}</h2>
    <div>
      <slot />
    </div>
  </div>
</template>

<script setup>
defineProps({
  title: String
})
</script>
